import { useRoutes } from 'react-router-dom';
import { useCrossTabLogout } from '@/hooks/useCrossTabLogout';
import { NotificationSnackbar } from '@/components/NotificationSnackbar';
import { routes } from './routes';

function App() {
  useCrossTabLogout();
  const element = useRoutes(routes);
  return (
    <>
      {element}
      <NotificationSnackbar />
    </>
  );
}

export default App;
